import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IAccountProfileGenerateRequest {
	accountId: string;
	transcriptContent: string;
	websiteUrl?: string;
}

export interface IAccountProfileGenerateResponse {
	businessDescription: string;
	keywords: string;
	contentGoals: string;
}

export function useAdminAccountProfileGenerateMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IAccountProfileGenerateRequest) => {
			return userSession.webServiceHelper.callAsync<IAccountProfileGenerateResponse>(
				'admin/zoom/account-profile/generate',
				'POST',
				request
			);
		},
	});
}
